export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11012.e844d176.jpg";